import { TnAAbsenceApprovalFilter } from "src/models/tna/tna-absences/tna-absence-approval-filter";
import { TnAAbsenceDTO, TnAAbsenceSTO } from "../../models/tna";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { BaseApiService } from "../base/base-api.service";

export class TnAAbsencesApiService extends BaseApiService<TnAAbsenceDTO, TnAAbsenceSTO> {
  constructor() {
    super({
      servicePath: "/TnAAbsences",
      loadItemsPath: "/GetTnAAbsences",
      saveItemsPath: "/SaveTnAAbsences",
    });
  }
}

export const saveAbsence = async (absence: TnAAbsenceSTO) => {
  const response = await new TnAAbsencesApiService().saveItems([absence]);

  toastifyResponse(response, "all", "default_success_message", "failure_saving_data", "error_saving_data");

  return response;
};

export const approveAbsense = async (
  employeeId: string,
  absenceId: string,
  isApprovedRejected: "isApproved" | "isRejected"
) => {
  const absenceToApproveReject = isApprovedRejected === "isApproved" ? "ApproveTnAAbsences" : "RejectTnAAbsences";

  const apiService = new TnAAbsencesApiService();
  apiService.useLoadItemsPath(`/${absenceToApproveReject}`);

  const response = await apiService.loadItems(
    {
      employeeId,
      absenceIds: [absenceId],
    } as TnAAbsenceApprovalFilter,
    undefined,
    [],
    undefined,
    undefined,
    60,
    undefined
  );

  toastifyResponse(response, "all", "default_success_message", "failure_saving_data", "error_saving_data");

  return response;
};

export const approveRejectCancellationRequest = async (
  employeeId: string,
  absenceId: string,
  isApprovedRejected: "isApproved" | "isRejected"
) => {
  const absenceCancellationToApproveReject =
    isApprovedRejected === "isApproved" ? "ApproveCancellationRequest" : "RejectCancellationRequest";

  const apiService = new TnAAbsencesApiService();
  apiService.useLoadItemsPath(`/${absenceCancellationToApproveReject}`);

  const response = await apiService.loadItems(
    {
      employeeId,
      absenceIds: [absenceId],
    } as TnAAbsenceApprovalFilter,
    undefined,
    [],
    undefined,
    undefined,
    60,
    undefined
  );

  toastifyResponse(response, "all", "default_success_message", "failure_saving_data", "error_saving_data");

  return response;
};
